module.exports = __webpack_public_path__ + "static/media/bgr-two-xxl.2003e055.webp";